<app-header
  icon="fas fa-cog"
  text="Allgemeines"
  sub="Definieren Sie die Grundeinstellungen Ihres Atlas."></app-header>
<p-divider />
<form *ngIf="form" [formGroup]="form" (ngSubmit)="submit()" class="p-fluid">
  <app-header icon="fas fa-image" text="Logo" />
  <div class="flex gap-5 align-items-end">
    @if (activeCommune?.atlasConfig?.logo; as logo) {
      <div class="p-card p-2">
        <app-logo hStyleClass="h-10rem w-14rem" [logoFileName]="logo" />
      </div>
    } @else {
      <div
        class="surface-ground p-card text-5xl flex align-items-center justify-content-center h-8rem w-12rem">
        <i class="fas fa-image"></i>
      </div>
    }

    <p-fileUpload
      mode="basic"
      chooseLabel="Bild auswählen"
      chooseIcon="pi pi-upload"
      name="logo"
      [url]="communeService.getLogoUploadUrl()"
      [auto]="true"
      accept="image/*"
      maxFileSize="1000000"
      (onUpload)="onUpload($event)" />
  </div>
  <p-divider />

  <app-header icon="fas fa-cog" text="Dezimalstellen" />
  <div class="grid">
    <div class="col-6">
      <div class="grid">
        <app-form-field-wrapper
          [label]="'absolut'"
          [name]="'absoluteDecimals'"
          [colSize]="2">
          <p-inputNumber
            id="absoluteDecimals"
            type="number"
            formControlName="absoluteDecimals"></p-inputNumber>
        </app-form-field-wrapper>
        <app-form-field-wrapper
          [label]="'relativ'"
          [name]="'relativeDecimals'"
          [colSize]="2">
          <p-inputNumber
            id="relativeDecimals"
            type="number"
            formControlName="relativeDecimals"></p-inputNumber>
        </app-form-field-wrapper>
      </div>
    </div>
  </div>
  <app-header icon="fas fa-palette" text="Farben"></app-header>
  <div class="grid">
    <app-colorset-dropdown
      [colSize]="5"
      formControlName="colorset"></app-colorset-dropdown>
  </div>

  <p-divider></p-divider>
  <app-header icon="fas fa-eye" text="Anzeige" />
  <div class="grid">
    <div class="col-12 flex align-items-center gap-2">
      <p-checkbox
        [binary]="true"
        label="Nummern in Indikatorenbaum anzeigen"
        formControlName="showIndicatorNumbers" />
    </div>
  </div>

  <p-divider></p-divider>
  <app-header
    icon="fas fa-globe"
    text="Externe Datenquellen - Wegweiser Kommune Daten" />

  <div class="flex flex-wrap gap-3">
    <div class="flex flex-column gap-1">
      <div class="flex align-items-center">
        <p-radioButton
          name="allowWegweiserData"
          value="all"
          formControlName="allowWegweiserData"
          inputId="all" />
        <label for="all" class="ml-2"> Immer erlauben </label>
      </div>
      <div
        class="ml-5 text-sm text-color-secondary font-light flex align-items-baseline gap-2">
        <i class="fas fa-info-circle"></i> Alle Nutzer:innen können auf
        öffentliche Wegweiserdaten zugreifen.
      </div>
    </div>

    <div class="flex flex-column gap-1">
      <div class="flex align-items-center">
        <p-radioButton
          name="allowWegweiserData"
          value="external"
          formControlName="allowWegweiserData"
          inputId="external" />
        <label for="external" class="ml-2"> Nur im öffentlichen Atlas </label>
      </div>
      <div
        class="ml-5 text-sm text-color-secondary font-light flex align-items-baseline gap-2">
        <i class="fas fa-info-circle"></i> Öffentliche Nutzer:innen können auf
        öffentliche Wegweiserdaten zugreifen. Im internen Atlas können keine
        Ansichten mit Wegweiserdaten erstellt werden.
      </div>
    </div>

    <div class="flex flex-column gap-1">
      <div class="flex align-items-center">
        <p-radioButton
          name="allowWegweiserData"
          value="internal"
          formControlName="allowWegweiserData"
          inputId="internal" />
        <label for="internal" class="ml-2"> Nur im internen Atlas </label>
      </div>
      <div
        class="ml-5 text-sm text-color-secondary font-light flex align-items-baseline gap-2">
        <i class="fas fa-info-circle"></i> Interne Nutzer:innen können auf
        öffentliche Wegweiserdaten zugreifen. Es können Ansichten mit
        Wegweiserdaten erstellt werden. Öffentliche Nutzer:innen können nicht
        selbstständig auf die Schnittstelle zugreifen.
      </div>
    </div>

    <div class="flex flex-column gap-1">
      <div class="flex align-items-center">
        <p-radioButton
          name="allowWegweiserData"
          value="none"
          formControlName="allowWegweiserData"
          inputId="none" />
        <label for="none" class="ml-2"> Immer deaktivieren </label>
      </div>
      <div
        class="ml-5 text-sm text-color-secondary font-light flex align-items-baseline gap-2">
        <i class="fas fa-info-circle"></i> Der Zugriff auf Wegweiserdaten ist
        deaktiviert. Bereits angelegte Ansichten sind weiterhin nutzbar.
      </div>
    </div>
  </div>
</form>
